﻿export * from './grado.component';
